<div class="app-wrapper">

  <div class="layout-container">
    
    <nav class="activity-bar">
      <div class="nav-top">
        <div class="logo-top">
          <img src="../../../assets/images/logo-neon.png" width="32" alt="EstimatIA" onerror="this.style.display='none'" />
        </div>

        <a *ngIf="isSuperAdmin || isTenantAdmin" routerLink="/app/home" routerLinkActive="active" class="action-icon" title="Dashboard">
          <svg viewBox="0 0 24 24" width="24" height="24"><path fill="currentColor" d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z"/></svg>
        </a>

        <a *appHasPermission="'menu:projects:manage'" routerLink="/app/proyectos" routerLinkActive="active" class="action-icon" title="Directorio de Proyectos">
          <svg viewBox="0 0 24 24" width="24" height="24"><path fill="currentColor" d="M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z"/></svg>
        </a>

        <a *appHasPermission="'menu:users:manage'" routerLink="/app/users" routerLinkActive="active" class="action-icon" title="Gestión de Usuarios">
          <svg viewBox="0 0 24 24" width="24" height="24"><path fill="currentColor" d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/></svg>
        </a>

        <a *appHasPermission="'menu:master:manage'" routerLink="/app/master-management" routerLinkActive="active" class="action-icon" title="Maestros (Configuración)">
          <svg viewBox="0 0 24 24" width="24" height="24"><path fill="currentColor" d="M19.14,12.94c0.04-0.3,0.06-0.61,0.06-0.94c0-0.32-0.02-0.64-0.06-0.94l2.03-1.58c0.18-0.14,0.23-0.41,0.12-0.61 l-1.92-3.32c-0.12-0.22-0.37-0.29-0.59-0.22l-2.39,0.96c-0.5-0.38-1.03-0.7-1.62-0.94L14.4,2.81c-0.04-0.24-0.24-0.41-0.48-0.41 h-3.84c-0.24,0-0.43,0.17-0.47,0.41L9.25,5.35C8.66,5.59,8.12,5.92,7.63,6.29L5.24,5.33c-0.22-0.08-0.47,0-0.59,0.22L2.73,8.87 C2.62,9.08,2.66,9.34,2.86,9.48l2.03,1.58C4.84,11.36,4.8,11.69,4.8,12s0.02,0.64,0.06,0.94l-2.03,1.58 c-0.18,0.14-0.23,0.41-0.12,0.61l1.92,3.32c0.12,0.22,0.37,0.29,0.59,0.22l2.39-0.96c0.5,0.38,1.03,0.7,1.62,0.94l0.36,2.54 c0.05,0.24,0.24,0.41,0.48,0.41h3.84c0.24,0,0.43-0.17,0.47-0.41l0.36-2.54c0.59-0.24,1.13-0.56,1.62-0.94l2.39,0.96 c0.22,0.08,0.47,0,0.59-0.22l1.92-3.32c0.12-0.22,0.07-0.49-0.12-0.61L19.14,12.94z M12,15.6c-1.98,0-3.6-1.62-3.6-3.6 s1.62-3.6,3.6-3.6s3.6,1.62,3.6,3.6S13.98,15.6,12,15.6z"/></svg>
        </a>

        <a *appHasPermission="'metrics:admin'" routerLink="/app/metricas" routerLinkActive="active" class="action-icon" title="Métricas del Sistema">
          <svg viewBox="0 0 24 24" width="24" height="24"><path fill="currentColor" d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z"/></svg>
        </a>

        <a *ngIf="isSuperAdmin" routerLink="/app/system-config" routerLinkActive="active" class="action-icon" title="Configuración Global (E2DB)">
          <svg viewBox="0 0 24 24" width="24" height="24"><path fill="currentColor" d="M20 13H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1zM7 19c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM20 3H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1zM7 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"/></svg>
        </a>

        <a *appHasPermission="'estimation:export'" routerLink="/app/exports" routerLinkActive="active" class="action-icon" title="Mis exportaciones">
          <svg viewBox="0 0 24 24" width="24" height="24"><path fill="currentColor" d="M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z"/></svg>
        </a>

        <div class="nav-separator" *ngIf="!isHome"></div>

        <a *ngIf="!isHome" (click)="openWizard()" class="action-icon ia-trigger" title="Lanzar RAGPT Wizard">
          <svg viewBox="0 0 24 24" width="24" height="24"><path fill="currentColor" d="M19 3h-1V1h-2v2h-1c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h4c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16h-4V5h4v14zM7 10h2v7H7zm-4 3h2v4H3z"/></svg>
        </a>
      </div>

      <div class="nav-bottom">
        <a routerLink="/app/profile" routerLinkActive="active" class="action-icon" title="Mi Perfil" style="margin-bottom: 10px;">
          <svg viewBox="0 0 24 24" width="24" height="24"><path fill="currentColor" d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/></svg>
        </a>

        <a (click)="logout()" class="action-icon logout-trigger" title="Cerrar Sesión">
          <svg viewBox="0 0 24 24" width="24" height="24"><path fill="currentColor" d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z"/></svg>
        </a>
      </div>
    </nav>

    <main class="content">
      <header class="top-bar" *ngIf="isSuperAdmin">
        <div class="top-bar-left">
          <span class="cyber-badge superadmin-badge">⚡ SUPERADMIN MODE</span>
        </div>
        <div class="top-bar-right">
          <span class="tenant-label">ENTORNO ACTIVO:</span>
          <select class="cyber-select" [(ngModel)]="selectedTenant" (change)="onTenantChange($event)">
            <option value="">[ GLOBAL / MANTENIMIENTO ]</option>
            <option *ngFor="let t of tenants" [value]="t.id">{{ t.name }}</option>
          </select>
        </div>
      </header>
      
      <router-outlet></router-outlet> 
    </main>
    
    <app-modal-estimation-wizard *ngIf="showModalWizard" (close)="closeWizard()"></app-modal-estimation-wizard>

  </div>
</div>